import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import PdxNavPanel from '../PdxNavPanel';
import PdxNavPanelSection from '../PdxNavPanel/PdxNavPanelSection';
import PdxNavPanelSectionHeader from '../PdxNavPanel/PdxNavPanelSectionHeader';
import PdxNavPanelSectionItem from '../PdxNavPanel/PdxNavPanelSectionItem';
import { LINK_IDS } from '../nav-links';
import { currentUserAddons } from '../../../features/fe-data/selectors';

export const AppsPanelComponent = ({ addons }) => {
  const userHasAddOns = addons.length > 0;

  const appsContent = (
    <React.Fragment>
      <PdxNavPanelSection split>
        <PdxNavPanelSectionHeader>Apps</PdxNavPanelSectionHeader>
        <PdxNavPanelSectionItem id={LINK_IDS.APP_DIRECTORY} />
        <PdxNavPanelSectionItem id={LINK_IDS.EXTENSIONS} />
        <PdxNavPanelSectionItem id={LINK_IDS.ADD_ON_SETTINGS} />
      </PdxNavPanelSection>
      <PdxNavPanelSection split>
        <PdxNavPanelSectionHeader>Developer Tools</PdxNavPanelSectionHeader>
        <PdxNavPanelSectionItem id={LINK_IDS.DEVELOPER_MODE} />
        <PdxNavPanelSectionItem id={LINK_IDS.API_ACCESS} />
        <PdxNavPanelSectionItem id={LINK_IDS.DOCUMENTATION} />
      </PdxNavPanelSection>
    </React.Fragment>
  );

  const addonsContent = (
    <PdxNavPanelSection split gray>
      <PdxNavPanelSectionHeader>Your Add-Ons</PdxNavPanelSectionHeader>
      {addons.map(a => (
        <PdxNavPanelSectionItem key={a.id} link={a.html_url}>
          {a.name}
        </PdxNavPanelSectionItem>
      ))}
    </PdxNavPanelSection>
  );

  return userHasAddOns
    ? (
      <PdxNavPanel split right={136} cols={3}>
        {addonsContent}
        {appsContent}
      </PdxNavPanel>
    )
    : (
      <PdxNavPanel right={136} cols={2}>
        {appsContent}
      </PdxNavPanel>
    );
};

AppsPanelComponent.propTypes = {
  addons: PropTypes.arrayOf(PropTypes.shape({
    addon_id: PropTypes.string,
    html_url: PropTypes.string,
    name: PropTypes.string
  })).isRequired
};

const mapStateToProps = state => ({
  addons: currentUserAddons(state)
});

export default connect(mapStateToProps)(AppsPanelComponent);
